import {useMutation} from "@apollo/client";
import {useCallback} from "react";
import {GENERATE_PUBLIC_TOKEN} from "./commands";

/**
 * Custom hook to update the user profile.
 * @param {Function} [onCompleted] - Callback function to be called when the mutation completes successfully.
 * @param {Function} [onError] - Callback function to be called when an error occurs during the mutation.
 * @returns {{updateProfile: Function, loading: boolean}} - The function to update the profile and the loading state.
 */
export function useGeneratePublicToken(
  onCompleted = () => {},
  onError = () => {},
) {
  const [comGeneratePublicToken, { loading }] = useMutation(
    GENERATE_PUBLIC_TOKEN,
    {
      onCompleted: ({ generatePublicToken }) => {
        onCompleted(generatePublicToken?.token);
      },
      onError,
      refetchQueries: ["GetPublicToken"],
    },
  );
  const generatePublicToken = useCallback(() => {
    comGeneratePublicToken().then();
  }, [comGeneratePublicToken]);
  return {
    generatePublicToken,
    loading,
  };
}
